<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">発見動画</div>
    </div>
    <div class="body_right_second">
      <el-button style="width: 152px;" type="primary" @click="addDialog = true"><i class="el-icon-plus"></i>&nbsp;&nbsp;動画を投稿</el-button>
      <el-button style="width: 130px;" @click="fetch()"><i class="el-icon-refresh-right"></i>&nbsp;&nbsp;更新</el-button>
    </div>
    <div class="body_right_third">
      <div style="padding: 15px 26px;">
        <div class="body_right_third_head">
          <div class="head_title">内容:<div class="input"><el-input v-model="searchFrom.content" placeholder="Title"/></div></div>
          <div class="head_title">トピック:
            <div class="input"><el-select style="width: 150px;" clearable v-model="searchFrom.postTopic" placeholder="请选择">
              <el-option
                v-for="item in postTopicList"
                :key="item.Id"
                :label="item.title"
                :value="item.id"
                style="width: 150px;">
              </el-option>
            </el-select></div>
          </div>
          <div class="head_title"><el-button style="background-color: #FF6633;color: #FFFFFF;width: 94px;border:0;" @click="getList()"><i class="el-icon-search"></i>&nbsp;&nbsp;検索</el-button></div>
        </div>
        <div class="body_right_third_scrollbar">
          <el-table
            ref="singleTable"
            border
            :data="list"
            v-loading="Loading"
            highlight-current-row
            height="670px"
            @current-change="handleCurrentChange"
            :default-sort = "{prop: 'date', order: 'descending'}"
            style="width: 100%;">
            <el-table-column label="ID" prop="id" type="index" align="center" width="60">
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="150" class-name="small-padding fixed-width">
              <template slot-scope="{row,$index}">
                <el-button type="primary" size="mini" @click="getComment(row)">
                  レビューを見る
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="投稿者" min-width="150" align="center">
              <template slot-scope="{row}">
                <span>{{ userInfo.nickname }}</span>
              </template>
            </el-table-column>
            <el-table-column label="投稿時間" prop="createdDate" sortable align="center" min-width="180">
              <template slot-scope="{row}">
                <span style="color: #3399CC;">{{getTime(row.createdDate)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="トピック" min-width="240" align="center">
              <template slot-scope="{row}">
                <span style="color: #3399CC;">{{ row.postTopic.title }}</span>
              </template>
            </el-table-column>
            <el-table-column label="ステータス" min-width="100" align="center">
              <template slot-scope="{row}">
                <el-tag :type="row.state=='NORMAL' ?'success':'danger'">{{ row.state == "NORMAL" ? '正常' : '未審査'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="「いいね！」の数" min-width="110" align="center">
              <template slot-scope="{row}">
                <span>{{ row.likeNum }}</span>
              </template>
            </el-table-column>
            <el-table-column label="閲覧数" min-width="110" align="center">
              <template slot-scope="{row}">
                <span>{{ row.readNum }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="シェアの数" min-width="110" align="center">
              <template slot-scope="{row}">
                <span>{{ row.shareNum }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="表紙" min-width="200" align="center">
              <template slot-scope="{row}">
                <span v-if="row.images">
                  <img v-for="n in row.images" :key="n" :src="n" style="width:24px;height:24px;"/>
                </span>
                <span v-else>无</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="内容" min-width="80" align="center">
              <template slot-scope="{row}">
                <i class="el-icon-view"  @click="lockcontent(row.title,row.videoUrl)"/>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="table_pagination">
            <pagination
              :total="total"
              :page.sync="page"
              :limit.sync="size"
              @pagination="getList"
            />
          </div>
        </div>
      </div>
    </div>
    <add-post v-if="addDialog" :addDialog.sync="addDialog" :postTopicList="postTopicList"></add-post>
    <post-dialog v-if="detailsDialog" :detailsDialog.sync="detailsDialog" :postList="postList" state="post"></post-dialog>
  </div>
</template>

<script>
  import * as json from '@/assets/js/json'
  import {previewHtml,getTime} from '@/assets/js/util'
  import addPost from '@/pages/homePage/manage/postManage/addPost'
  import Pagination from "@/components/Pagination"; 
  import postDialog from '@/components/Dialog'
  export default {
    components: {
      addPost,
      Pagination,
      postDialog
    },
    data () {
      return {
        userInfo:{},
        list: [],
        postTopicList:[],
        searchFrom: {
          content: null,
          postTopic: null,
          type: 'post',
        },
        addDialog: false,
        page: 1,
        size: 10,
        total: 0,
        Loading: false,
        detailsDialog: false,
        postList: {},
      }
    },
    created () {
      this.userInfo = this.$store.state.userInfo
      this.fetch()
    },
    methods: {
      fetch(){
        this.searchFrom = {
          content: null,
          postTopic: null,
          type: 'post',
        }
        this.getPostTopicList()
        this.getList()
      },
      getList(){
        this.Loading = true
        this.searchFrom.size = this.size
        this.searchFrom.current = this.page
        json.post('/api/member/post/my_create_web', this.searchFrom).then((res) => {
          if (res.data.success) {
            this.list = res.data.data.posts.records
            this.total = res.data.data.posts.total
            this.Loading = false
          }
        })
      },
      getComment(rew){
        this.detailsDialog = true
        this.postList = rew
      },
      getPostTopicList(){
        json.uploadPost('/api/member/post_topic/week_list?size=100&current=1').then((res) => {
          if (res.data.success) {
            this.postTopicList = res.data.data.weekPostTopics
          }
        })
      },
      openPosts(id){
      },
      locktag(id) {
        json.uploadPost('/api/userSystem/article/tag/list/'+id).then((res) => {
          if (res.data.success) {
            this.articleTags = res.data.articleTags;
            this.dialogPvVisible = true;
          }
        })
      },
      handleSizeChange(){
        
      },
      handleCurrentChange(){

      },
      getTime(timestamp){
        return getTime(timestamp);
      }
    }
  }
</script>

<style src="@/pages/homePage/manage/index.css" scoped>
</style>

